<template>
	<div class="page_content module_person" aria-label="Person Page Content">

	    <div class="hidden-container">
	      <form method="POST" id="multipleFileUploadForm" enctype="multipart/form-data" v-on:submit.prevent>
	        <input type="file" id="thumbnailFileList" ref="thumbnailFileList" name="thumbnailFile" @change="thumbnailToBeUploaded" />
	        <input type="file" id="fileListId" ref="fileInput" name="fileList" rel="multipleFile" @change="fileToBeUploaded" />
	      </form>
	    </div>

		<div class="row page-heading">
			<div class="col-8 input module_heading">
	        	<div class="module_icon ico-mentor"></div>
	        	<b-input-group class="input_grp">
	          		<select id="namePrefix" v-model="namePrefix">
									<option value="">Select</option>
	            		<option v-for="type in personPrefixTypes" v-model="namePrefix">
	              			{{ type }}
	            		</option>
	          		</select>
	          		<b-form-input id="newFirstName" v-model="firstName" placeholder="first *"></b-form-input>
	          		<b-form-input id="newMiddleName" v-model="middleName" placeholder="middle"></b-form-input>
	          		<b-form-input id="newLastName" v-model="lastName" placeholder="last *"></b-form-input>
	          		<b-form-input id="nameSuffix" v-model="nameSuffix" placeholder="suffix" class="name_suffix"></b-form-input>
	        	</b-input-group>
	      	</div>
	      	<div class="btn-container col-4">
				<button class="btn-cancel" @click="cancelClicked"><span class="icon-cross" aria-label="close"></span></button>
	          	<button :class="{disabled: !personDataIsValid}" class="btn btn-primary" @click.stop="onSubmit(true)" :disabled="submitted" aria-label="done">done</button>
	          	<button :class="{disabled: !personDataIsValid}" class="btn btn-primary" @click.stop="onSubmit(false)" aria-label="save">save</button>
	      	</div>
	    </div>


	    <div class="page-content">

		    <div class="row section_row">

		    	<div class="heading">
		    		<div class="ic"></div>
		    		<div class="hd_txt">Basic Details</div>
		    		<div class="btn_container"></div>
		    	</div> <!-- heading -->

		    	<div class="section_content basic_details">

		    		<div class="person_thumbnail">
		    			<div class="thumbnail_container">
		    				<span class="icon-pencil" @click="addThumbnailClicked"></span>
		            		<img v-if="showPreview && thumbnailURI" id="personThumbnail" :src="thumbnailURI" class="thumbnail_image">
		            		<span v-else class="ic ico-mentor"></span>
		          		</div>


		          		<b-modal ref="modal" id="addNewThumbnail" v-model="showAddThumbnailModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered class="modal_popup popup_add_thumbnail">
                          <div slot="modal-header" class="popover-header">
							<div class="popup-heading">Update Thumbnail</div>
							<button class="btn_close" aria-label="close" @click="cancelAddThumbnail">
							   <span class="ic-close"></span>
							</button>
						  </div>
		          			<div class="row">

	                			<div class="col-4">
	                   				<div class="thumbnail_msg">How your thumbnail will appear</div>
	                   				<div class="thumbnail_container">
															<b-btn v-if="isUploadingThumbnail || (thumbnail && thumbnail.length > 0)" @click.stop="removeThumbnailClicked" class="btn">remove thumbnail</b-btn>
	                   					<img v-if="showPreview && thumbnailURI" id="careerThumbnail" :src="thumbnailURI">
	                   					<span v-else class="ic ico-mentor"></span>
	                   				</div>
                            <span v-if="!showPreview">Preview unavailable</span>
	                			</div>

	                			<div class="col-7 right-model-box">

	                   				<div class="row fld_row">
	                   					<div class="col-1 fld_col_label">
	                  						<label>URL</label>
	                  					</div>
	                  					<div class="col-8 fld_col_input">
	                   						<input :disabled="isUploadingThumbnail" v-model="thumbnailURI" placeholder="http://"></input>
	                   					</div>
	                   					<div class="col-3 btn_container">
	                   					</div>
	                   				</div>

	                   				<div class="row fld_row msg_row">
	                   					<div class="col-1"></div>
	                   					<div class="col-11 msg">Add image url for thumbnail.</div>
	                    			</div>

	                    			<div class="row txt_sep_row">
	                    				<div class="col-12">OR</div>
	                    			</div>

	                    			<div class="row fld_row">
	                    				<div class="col-1 fld_col_label">
	                    					<label for="newThumbnailFileName">File</label>
	                    				</div>
	                    				<div class="col-8 fld_col_input">
	                    					<input id="newThumbnailFileName" disabled v-model="thumbnail" placeholder="choose a file from your computer"></input>
	                    				</div>
	                   					<div class="col-3 fld_col_btn">
	                    					<b-btn :disabled="isUploadingThumbnail" @click.stop="chooseFile(true)">add file</b-btn>
	                    				</div>
	                    			</div>

	                    			<div class="row msg_row">
	                   					<div class="col-1"></div>
	                   					<div class="col-11 msg">Select a jpg, jpeg, bmp, gif or png file.</div>
	                    			</div>

	                			</div>

                			</div>


                 			<div slot="modal-footer">
                    			<b-btn @click="addNewThumbnail">save and next</b-btn>
                    			<b-btn @click="cancelAddThumbnail">cancel</b-btn>
                			</div>
            			</b-modal>

		          		<!--
		          		<b-modal ref="modal" id="addNewThumbnail" title="Update Thumbnail" v-model="showAddThumbnailModal" no-close-on-esc ok-only class="modal_popup">
			        			<b-input-group>
					              	<span>
					                	<label class="heading" for="newThumbnailUrl">URL</label>
					               		<input :id="newThumbnailUrl" :disabled="isUploadingThumbnail" v-model="thumbnailURI" placeholder="http://"></input>
					              	</span>
			          				<span>OR</span>
			          				<span>
			            				<label class="heading" for="newThumbnailFileName">File</label>
			            				<input id="newThumbnailFileName" disabled v-model="thumbnail" placeholder="choose a file from your computer"></input>
			            				<b-btn :disabled="!isUploadingThumbnail" @click.stop="chooseFile(true)">replace file</b-btn>
			            				<b-btn @click.stop="removeThumbnailClicked">x</b-btn>
			          				</span>
			        			</b-input-group>
			        			<div slot="modal-footer">
			          				<b-btn @click="cancelAddThumbnail">
			            				cancel
			          				</b-btn>
			          				<b-btn @click="addNewThumbnail">
			            				save and next
			          				</b-btn>
			        			</div>
			      			</b-modal>
			      			-->

						<div class="details_row person_type">
		            		<label class="label" for="personType">Person Type: </label>
				            <select id="personType" v-model="personType">
											<option value="">Select</option>
				            	<option v-for="type in personTypes" v-model="personType">
				                	{{ type }}
				              	</option>
							</select>
		          		</div>
		    		</div>

		    		<div class="person_details">

		    			<!--
		    			<div class="details_row name_row" style="width: 100%;">
		    				Name: {{firstName}} {{middleName}} {{lastName}}
		    			</div>
		    			-->

		    			<div class="row details_row">

		    				<div class="col-5">
			    				<div class="row_title">
			    					<label for="personPhoneNumbers">Phone</label> <b-btn @click="addPhoneClicked">add</b-btn>
			    				</div>

				    			<div class="row_value" v-if="contactInfo && contactInfo.phoneList && contactInfo.phoneList.length">
					              	<div id="personPhoneNumbers" class="row_val_txt" v-for="number in contactInfo.phoneList">
					                	<span v-if="number && number.type && number.value">
					                		<span class="txt">{{number.type}}: {{number.value}}</span>
					                		<span class="icon-bin" @click="removeItemFromList(contactInfo.phoneList, number)"></span>
					                	</span>
					              	</div>
					            </div>
					            <div class="col_blank empty_pattern" v-if="contactInfo.phoneList.length == 0"></div>

					            <b-modal ref="modal" id="addNewPhone" v-model="showAddPhoneModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered class="modal_popup">
								   <div slot="modal-header" class="popover-header">
									<div class="popup-heading">Phone</div>
									<button class="btn_close" aria-label="close" @click="cancelAddPhone">
									   <span class="ic-close"></span>
									</button>
								  </div>
					               <div class="row fld_row">
	                   					<div class="col-3">
	                   						<select id="newPhoneType" v-model="newPhoneType">
												option value="">Select</option>
					                            <option v-for="type in phoneTypes" v-model="newPhoneType">
					                              {{ type }}
					                           	</option>
					                       </select>
											 <span class="fld_req" style="margin-top: -2px; float: right;">*</span>
					                  	</div>
	                   					<div class="col-8 fld_col_input">
	                   						 <input id="newPhoneNumber" v-model="newPhoneNumber" placeholder="type in phone"></input>
	                   						 <span class="fld_req">*</span>
	                   					</div>
	                    			</div>

					              <div slot="modal-footer">
					                <b-button-group>
					                  <span v-if="errors && errors.length > 0">{{errors}}</span>
					                  <b-btn @click="cancelAddPhone">
					                    cancel
					                  </b-btn>
					                  <b-btn @click="addNewPhone">
					                    save and next
					                  </b-btn>
					                </b-button-group>
					              </div>
					            </b-modal>
							</div>

							<div class="col-1"></div>

							<div class="col-5">
			    				<div class="row_title">
			    					<label for="personEmails">Email</label> <b-btn @click="addEmailClicked">add</b-btn>
			    				</div>

			    				<div class="row_value" v-if="contactInfo && contactInfo.eMailList && contactInfo.eMailList.length">
					              	<div id="personEmails" class="row_val_txt" v-for="email in contactInfo.eMailList">
					                	<span v-if="email && email.type && email.value">
					                		<span class="txt">{{email.type}}: {{email.value}}</span>
					                		<span class="icon-bin" @click="removeItemFromList(contactInfo.eMailList, email)"></span>
					                	</span>
					              	</div>
					            </div>
					            <div class="col_blank empty_pattern" v-if="contactInfo.eMailList.length == 0"></div>

					            <b-modal ref="modal" id="addNewEmail" v-model="showAddEmailModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered class="modal_popup">
								     <div slot="modal-header" class="popover-header">
										<div class="popup-heading">Email</div>
										<button class="btn_close" aria-label="close" @click="cancelAddEmail">
										   <span class="ic-close"></span>
										</button>
									  </div>
					                <div class="row fld_row">
	                   					<div class="col-3">
	                   						<select id="newEmailType" v-model="newEmailType">
																		<option value="">Select</option>
					                         	<option v-for="type in emailTypes" v-model="newEmailType">
					                         		{{ type }}
					                        	</option>
					                       </select>
																 <span class="fld_req" style="margin-top: -2px; float: right;">*</span>
					                  	</div>
	                   					<div class="col-8 fld_col_input">
	                   						 <input id="newEmailAddress" v-model="newEmailAddress" placeholder="type in email" type="email"></input>
											 <span class="fld_req">*</span>
	                   					</div>
	                    			</div>


					              <div slot="modal-footer">
					                <b-button-group>
					                  <span v-if="errors && errors.length > 0">{{errors}}</span>
					                  <b-btn @click="cancelAddEmail">
					                    cancel
					                  </b-btn>
					                  <b-btn @click="addNewEmail">
					                    save and next
					                  </b-btn>
					                </b-button-group>
					              </div>
					            </b-modal>
			    			</div>

		    			</div>


						<div class="row details_row details_second_row">

			          		<div class="col-5">
			          			<div class="row_title">
			    					<label for="personSocialList">Social</label> <b-btn @click="addSocialClicked">add</b-btn>
			    				</div>

					    		<div class="row_value" v-if="contactInfo && contactInfo.socialList && contactInfo.socialList.length">
					              	<div id="personSocialList" class="row_val_txt" v-for="social in contactInfo.socialList">
					                	<span v-if="social && social.type && social.value">
					                		<span class="txt">{{social.type}}: {{social.value}}</span>
					                		<span class="icon-bin" @click="removeItemFromList(contactInfo.socialList, social)"></span>
					                	</span>
					                	<br v-if="social && social.type && social.value">
					              	</div>
					            </div>
					            <div class="col_blank empty_pattern" v-if="contactInfo.socialList.length == 0"></div>

					            <b-modal ref="modal" id="addNewSocial" v-model="showAddSocialModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered class="modal_popup">
								   <div slot="modal-header" class="popover-header">
									<div class="popup-heading">Social</div>
									<button class="btn_close" aria-label="close" @click="cancelAddSocial">
									   <span class="ic-close"></span>
									</button>
								  </div>

					            	<div class="row fld_row">
	                   					<div class="col-3">
	                   						<select id="newSocialType" v-model="newSocialType">
																  <option value="">Select</option>
					                    		<option v-for="type in socialTypes" v-model="newSocialType">
					                      			{{ type }}
					                    		</option>
					                  		</select>
																<span class="fld_req" style="margin-top: -2px; float: right;">*</span>
					                  	</div>
	                   					<div class="col-8 fld_col_input">
	                   						<input id="newPhoneNumber" v-model="newSocialUrl" placeholder="type in social networking url"></input>
	                   						<span class="fld_req">*</span>
	                   					</div>
	                    			</div>

					              	<div slot="modal-footer">
					                	<b-button-group>
					                  		<span v-if="errors && errors.length > 0">{{errors}}</span>
					                  		<b-btn @click="cancelAddSocial">cancel</b-btn>
					                  		<b-btn @click="addNewSocial">save and next</b-btn>
					                	</b-button-group>
					              	</div>
					            </b-modal>
					    	</div>

							<div class="col-1"></div>

							<div class="col-5">
								<div class="row_title">
						    		<label for="personSocialList">Website</label> <b-btn @click="addWebsiteClicked">add</b-btn>
						    	</div>

					    		<div class="row_value" v-if="contactInfo && contactInfo.websiteList && contactInfo.websiteList.length" >
					              	<div id="personSocialList" class="row_val_txt" v-for="website in contactInfo.websiteList">
					              		<span v-if="website && website.value" >
					              			<span class="txt">{{website.value}}</span>
					              			<span class="icon-bin" @click="removeItemFromList(contactInfo.websiteList, website)"></span>
					              		</span>
					              	</div>
					            </div>
					            <div class="col_blank empty_pattern" v-if="contactInfo.websiteList.length == 0"></div>

					            <b-modal ref="modal" id="addNewWebsite" v-model="showAddWebsiteModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered class="modal_popup">
								    <div slot="modal-header" class="popover-header">
										<div class="popup-heading">Website</div>
										<button class="btn_close" aria-label="close" @click="cancelAddWebsite">
										   <span class="ic-close"></span>
										</button>
									  </div>

					            	<div class="row fld_row">
	                   					<div class="col-2 fld_col_label">
	                   					<label for="websiteUrlTitle"> URL <span class="fld_req">*</span></label>

					                  	</div>
	                   					<div class="col-10 fld_col_input">
	                   						<input id="newPhoneNumber" v-model="newWebsiteUrl" placeholder="http://"></input>
	                   					</div>
	                    			</div>

					              <div slot="modal-footer">
					                <b-button-group>
					                  <span v-if="errors && errors.length > 0">{{errors}}</span>
					                  <b-btn @click="cancelAddWebsite">
					                    cancel
					                  </b-btn>
					                  <b-btn @click="addNewWebsite">
					                    save and next
					                  </b-btn>
					                </b-button-group>
					              </div>
					            </b-modal>
						    </div> <!-- details_row -->

						</div>

		    		</div>

		    	</div> <!-- section_content -->

		    </div> <!-- section_row -->



			<div class="row section_row">
		    	<div class="heading">
		    		<div class="ic"></div>
		    		<div class="hd_txt">Biography</div>
		    		<div class="btn_container"></div>
		    	</div> <!-- heading -->

		    	<div class="section_content">
		    		<template>
		              <editor api-key="no-api-key" v-model="biography" :init="{plugins: plugins, toolbar: toolbar, image_advtab: true, file_picker_callback: filePickerCallback}" id="htmlBodyEditor"></editor>
		            </template>
		    	</div> <!-- section_content -->
		    </div> <!-- section_row -->



			<div class="row section_row">
		    	<div class="heading">
		    		<div class="ic"></div>
		    		<div class="hd_txt"><label for="personAreaOfInterest">Area of Interest</label></div>
		    		<div class="btn_container"><b-btn @click="addInterestClicked">add</b-btn></div>
		    	</div> <!-- heading -->

                <div class="section_content">
                   <div class="icon-container" style="margin-right: 24px; float: left;">
					   <span class="icon ic-tag" style="font-size: 32px; color: #787878;"></span>
					</div>
		    	     <div class="main-content tags_container">
		    		 <template v-if="areaOfInterestTerms && areaOfInterestTerms.length && areaOfInterestTerms.length > 0" class="tag-row">

		              <div id="personAreaOfInterest" class="tag ace_sec_txt" v-for="interest in areaOfInterestTerms" style="background: #e0f2ff;">
		                <span v-if="interest" class="tag_name instructional_tag"> {{interest}}</span>
										<span class="action">
											<span class="delete-icon">
												<span class="icon-bin" @click="removeItemFromList(areaOfInterestTerms, interest)"></span>
											</span>
										</span>
		              </div>
		            </template>

		            <b-modal ref="modal" id="addNewInterest" v-model="showAddInterestModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered class="modal_popup">
					 <div slot="modal-header" class="popover-header">
						<div class="popup-heading">Area of Interest</div>
						<button class="btn_close" aria-label="close" @click="showAddInterestModal = false">
						   <span class="ic-close"></span>
						</button>
					  </div>
						<span id="personAreaOfInterest" class="tag ace_sec_txt" v-for="interest in areaOfInterestTerms" style="background: #e0f2ff;">
		              	<span v-if="interest" class="tag_name instructional_tag"> {{interest}}</span>
		                            <span class="action">
                                         <span class="delete-icon">
                                            <span class="icon-bin" @click="removeItemFromList(areaOfInterestTerms, interest)"></span>
                                         </span>
                                    </span>
		                </span>
		              <div slot="modal-footer">
	                	<input id="newInterest" v-on:keyup.enter="addNewInterest" v-model="newInterest" placeholder="add interest, enter to continue adding" style="float: left;"></input>
	                	<b-btn @click="showAddInterestModal = false">ok</b-btn>
		              </div>
		            </b-modal>
		    	</div> <!-- section_content -->
		    	</div>
		    </div> <!-- section_row -->



			<div class="row section_row">
		    	<div class="heading">
		    		<div class="ic"></div>
		    		<div class="hd_txt"><label for="personExperience">Experience</label></div>
		    		<div class="btn_container"><b-btn @click="addExperienceClicked">add</b-btn></div>
		    	</div> <!-- heading -->

		    	<div class="section_content">
		    		<template v-if="experienceInfoList && experienceInfoList.length && experienceInfoList.length > 0">
			    		<div class="row">
			              	<div id="personExperience" class="col-xl-12 col-lg-12 col-md-12 col-sm-12 sec_col" v-for="experience in experienceInfoList">
			              		<div class="row">
					                <div class="col-12 col_txt_row" v-if="experience.title">
					                	<span class="title">Title: {{experience.title}}</span>
					                	<span class="icon-pencil" @click="editExperience(experience)"></span>
					                	<span class="icon-bin" @click="removeItemFromList(experienceInfoList, experience)"></span>
					                </div>
					                <div class="col-12 col_txt_row" v-if="experience.description">Description: {{experience.description}}</div>
					                <div class="col-12 col_txt_row" v-if="experience.employer">Employer: {{experience.employer}}</div>
					                <div class="col-12 col_txt_row" v-if="experience.industry">Industry: {{experience.industry}}</div>
					                <div class="col-12 col_txt_row" v-if="experience.location">Location: {{experience.location}}</div>
					                <div class="col-12 col_txt_row" v-if="experience.experienceTimeLabel">Duration: {{experience.experienceTimeLabel}}</div>
				                </div>
			              	</div>
		              	</div>
		            </template>

		            <b-modal ref="modal" id="addNewExperience" v-model="showAddExperienceModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered class="modal_popup">
					    <div slot="modal-header" class="popover-header">
							<div class="popup-heading">Experience</div>
							<button class="btn_close" aria-label="close" @click="cancelAddNewExperience">
							   <span class="ic-close"></span>
							</button>
						  </div>

		            	<div class="row fld_row">
           					<div class="col-3 fld_col_label">
           						<label for="newJobTitle"> Job Title <span class="fld_req">*</span></label>
		                  	</div>
           					<div class="col-8 fld_col_input">
           						<input id="newJobTitle" v-model="newJobTitle" placeholder="type in job title"></input>
           					</div>
            			</div>

            			<div class="row fld_row">
           					<div class="col-3 fld_col_label">
           						<label for="newJobDescription">Description</label>
		                  	</div>
           					<div class="col-8 fld_col_input">
           						<input id="newJobDescription" v-model="newJobDescription" placeholder="type in job description"></input>
           					</div>
            			</div>

            			<div class="row fld_row">
           					<div class="col-3 fld_col_label">
           						<label for="newJobEmployer"> Employer <span class="fld_req">*</span></label>
		                  	</div>
           					<div class="col-8 fld_col_input">
           						<input id="newJobEmployer" v-model="newEmployer" placeholder="type in employer"></input>
           					</div>
            			</div>

            			<div class="row fld_row">
           					<div class="col-3 fld_col_label">
           						<label for="newJobIndustry"> Industry <span class="fld_req">*</span></label>
		                  	</div>
           					<div class="col-8 fld_col_input">
           						<input id="newJobIndustry" v-model="newIndustry" placeholder="type in industry"></input>
           					</div>
            			</div>

            			<div class="row fld_row">
           					<div class="col-3 fld_col_label">
           						<label for="newJobLocation"> Location <span class="fld_req">*</span></label>
		                  	</div>
           					<div class="col-8 fld_col_input">
           						<input id="newJobLocation" v-model="newExperienceLocation" placeholder="type in new job location"></input>
           					</div>
            			</div>

            			<div class="row fld_row">
           					<div class="col-3 fld_col_label">
           						<label for="newExperienceStart">Start</label>
		                  	</div>
           					<div class="col-4 fld_col_input">
	           					<select id="newExperienceStartMonth" v-model="newExperienceStartMonth">
			                      <option v-for="month in months" v-model="newExperienceStartMonth">
			                        {{ month }}
			                      </option>
			                    </select>
           					</div>
           					<div class="col-4 fld_col_input">
			                    <select id="newExperienceStartYear" v-model="newExperienceStartYear">
			                      <option v-for="year in years" v-model="newExperienceStartYear">
			                        {{ year }}
			                      </option>
			                    </select>
           					</div>
            			</div>

            			<div class="row fld_row">
           					<div class="col-3 fld_col_label">
           					 	<label for="newExperienceEnd">End</label>
		                  	</div>
           					<div class="col-4 fld_col_input" v-if="!isPursuingExperience">
	                    		<select id="newExperienceEndMonth" v-model="newExperienceEndMonth">
	                      			<option v-for="month in months" v-model="newExperienceEndMonth">
	                        			{{ month }}
	                      			</option>
	                    		</select>
           					</div>
           					<div class="col-4 fld_col_input" v-if="!isPursuingExperience">
	                    		<select id="newExperienceEndYear" v-model="newExperienceEndYear">
	                      			<option v-for="year in years" v-model="newExperienceEndYear">
	                        			{{ year }}
	                      			</option>
	                    		</select>
           					</div>
           					<div v-else class="col-8 fld_col_label" style="text-align: left;">
	                    		- Present
	                  		</div>
            			</div>

            			<div class="row fld_row">
           					<div class="col-3 fld_col_label">
		                  		<input type="checkbox" id="pursuingCheckbox" v-model="isPursuingExperience">
		                  	</div>
		                  	<div class="col-8 fld_col_label" style="text-align: left;">
		                  		<label for="pursuingCheckbox">I currently work here</label>
		                  	</div>
            			</div>


		              <div slot="modal-footer">
		                <b-button-group>
		                  <span v-if="errors && errors.length > 0">{{errors}}</span>
		                  <b-btn @click="cancelAddNewExperience">
		                    cancel
		                  </b-btn>
		                  <b-btn @click="addNewExperience">
		                    save and next
		                  </b-btn>
		                </b-button-group>
		              </div>
		            </b-modal>
		    	</div> <!-- section_content -->
		    </div> <!-- section_row -->


			<div class="row section_row">
		    	<div class="heading">
		    		<div class="ic"></div>
		    		<div class="hd_txt"><label for="personEducation">Education</label></div>
		    		<div class="btn_container"><b-btn @click="addEducationClicked">add</b-btn></div>
		    	</div> <!-- heading -->

		    	<div class="section_content">
		    		<template v-if="educationInfoList && educationInfoList.length && educationInfoList.length > 0">
						<div class="row">
				          	<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 sec_col" id="personEducation" v-for="education in educationInfoList">
				          		<div class="row">
					                <div class="col-12 col_txt_row">
					                	<span class="title" v-if="education.degree && education.classOf">Degree: {{education.degree}}, Class of {{education.classOf}}</span>
					                	<span class="icon-pencil" @click="editEducation(education)"></span>
					                	<span class="icon-bin" @click="removeItemFromList(educationInfoList, education)"></span>
					                </div>
					                <div class="col-12 col_txt_row" v-if="education.institution">Institution: {{education.institution}}</div>
					                <div class="col-12 col_txt_row" v-if="education.majorOne">Major One: {{education.majorOne}}</div>
					                <div class="col-12 col_txt_row" v-if="education.majorTwo">Major Two: {{education.majorTwo}}</div>
					                <div class="col-12 col_txt_row" v-if="education.educationTimeLabel">Duration: {{education.educationTimeLabel}}</div>
				                </div>
				        	</div>
			        	</div>
					</template>

		            <b-modal ref="modal" id="addNewEducation" v-model="showAddEducationModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered class="modal_popup">
					 <div slot="modal-header" class="popover-header">
						<div class="popup-heading">Education</div>
						<button class="btn_close" aria-label="close" @click="cancelAddNewEducation">
						   <span class="ic-close"></span>
						</button>
					  </div>

		            	<div class="row fld_row">
           					<div class="col-3 fld_col_label">
           						<label for="newInstitutionName"> Institution <span class="fld_req">*</span></label>
		                  	</div>
           					<div class="col-8 fld_col_input">
           						<input id="newInstitutionName" v-model="newInstitutionName" placeholder="name of institution"></input>
           					</div>
            			</div>

            			<div class="row fld_row">
           					<div class="col-3 fld_col_label">
           						<label for="newDegree"> Degree <span class="fld_req">*</span></label>
		                  	</div>
           					<div class="col-8 fld_col_input">
           						<input id="newDegree" v-model="newDegree" placeholder="academic degree or diploma"></input>
           					</div>
            			</div>

            			<div class="row fld_row">
           					<div class="col-3 fld_col_label">
           						<label for="newGraduationYear"> Class of <span class="fld_req">*</span></label>
		                  	</div>
           					<div class="col-8 fld_col_input">
           						<select id="newGraduationYear" v-model="newGraduationYear">
				                	<option v-for="year in years" v-model="newGraduationYear">
				                    	{{ year }}
				                    </option>
				           		</select>
           					</div>
            			</div>

            			<div class="row fld_row">
           					<div class="col-3 fld_col_label">
           						<label for="newMajorOne">Major <span class="fld_req">*</span></label>
		                  	</div>
           					<div class="col-8 fld_col_input">
           						<input id="newMajorOne" v-model="newMajorOne" placeholder="primary field of study"></input>
           					</div>
            			</div>

            			<div class="row fld_row">
           					<div class="col-3 fld_col_label">
           						<label for="newMajorTwo">Second Major</label>
		                  	</div>
           					<div class="col-8 fld_col_input">
           						<input id="newMajorTwo" v-model="newMajorTwo" placeholder="other primary field of study (if any)"></input>
           					</div>
            			</div>

            			<div class="row fld_row">
           					<div class="col-3 fld_col_label">
           						<label for="newMinor">Minor</label>
		                  	</div>
           					<div class="col-8 fld_col_input">
           						<input id="newMinor" v-model="newMinor" placeholder="secondary field of study"></input>
           					</div>
            			</div>

            			<div class="row fld_row">
           					<div class="col-3 fld_col_label">
           						<label for="newConcentration">Concentration</label>
		                  	</div>
           					<div class="col-8 fld_col_input">
           						<input id="newConcentration" v-model="newConcentration" placeholder="area of specialization"></input>
           					</div>
            			</div>

            			<div class="row fld_row">
           					<div class="col-3 fld_col_label">
           						<label for="newEducationStart">Start</label>
		                  	</div>
           					<div class="col-4 fld_col_input">
	           					<select id="newEducationStartMonth" v-model="newEducationStartMonth">
			                      	<option v-for="month in months" v-model="newEducationStartMonth">
			                        	{{ month }}
			                      	</option>
			                    </select>
           					</div>
           					<div class="col-4 fld_col_input">
           						<select id="newEducationStartYear" v-model="newEducationStartYear">
		                      		<option v-for="year in years" v-model="newEducationStartYear">
		                        		{{ year }}
		                      		</option>
		                    	</select>
           					</div>
            			</div>

            			<div class="row fld_row">
           					<div class="col-3 fld_col_label">
           						<label for="newEducationEnd">End</label>
		                  	</div>
           					<div class="col-4 fld_col_input" v-if="!isPursuingEducation">
           						<select id="newEducationEndMonth" v-model="newEducationEndMonth">
		                      		<option v-for="month in months" v-model="newEducationEndMonth">
		                        		{{ month }}
		                      		</option>
		                    	</select>
           					</div>
           					<div class="col-4 fld_col_input" v-if="!isPursuingEducation">
           						<select id="newEducationEndYear" v-model="newEducationEndYear">
		                      		<option v-for="year in years" v-model="newEducationEndYear">
		                        		{{ year }}
		                      		</option>
		                    	</select>
           					</div>
           					<div class="col-8 fld_col_label" style="text-align: left;" v-else>
		                    	- Present
           					</div>
            			</div>

            			<div class="row fld_row">
           					<div class="col-3 fld_col_label" style="text-align: right;">
           						<input type="checkbox" id="pursuingCheckbox" v-model="isPursuingEducation">
		                  	</div>
           					<div class="col-8 fld_col_label" style="text-align: left;">
           						<label for="pursuingCheckbox">Currently pursuing</label>
           					</div>
            			</div>



		              <div slot="modal-footer">
		                <b-button-group>
		                  <span v-if="errors && errors.length > 0">{{errors}}</span>
		                  <b-btn @click="cancelAddNewEducation">
		                    cancel
		                  </b-btn>
		                  <b-btn @click="addNewEducation">
		                    save and next
		                  </b-btn>
		                </b-button-group>
		              </div>
		            </b-modal>
		    	</div> <!-- section_content -->
		    </div> <!-- section_row -->


			<div class="row section_row">
		    	<div class="heading">
		    		<div class="ic"></div>
		    		<div class="hd_txt"><label for="personTags">Tags</label></div>
		    		<div class="btn_container"><b-btn @click="showAddTagPopup($event)">add</b-btn></div>
		    	</div> <!-- heading -->

		    	<div class="section_content">
                    <div class="icon-container" style="margin-right: 24px; float: left;">
					   <span class="icon ic-tag" style="font-size: 32px;"></span>
					</div>
                    <div class="main-content tags_container">
    					<template v-for="(values, key, i) in appliedTagMap" class="tag-row">
                            <div id="personTags" class="tag ace_sec_txt" v-for="(tag, j) in values">
                                <span class="tag_name instructional_tag">{{tag.name}}</span>
                            </div>
                        </template>
		    	     </div>
		    	</div> <!-- section_content -->
		    	<template>
                    <add-tag-popup v-if="isShowTagPopup" :entity-data="taggingEntityData"></add-tag-popup>
                </template>
		    </div> <!-- section_row -->


			<div class="row section_row">
		    	<div class="heading">
		    		<div class="ic"></div>
		    		<div class="hd_txt"><label for="personResume">Resume</label></div>
		    		<div class="btn_container"><b-btn @click="addResumeClicked">edit</b-btn></div>
		    	</div> <!-- heading -->

		    	<div class="section_content">

		              	<div v-if="curriculumVitae.fileName"> {{ curriculumVitae.fileName }} </div>

		    		<b-modal ref="modal" id="addNewResume" v-model="showAddResumeModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered class="modal_popup">
					  <div slot="modal-header" class="popover-header">
						  <div class="popup-heading">Add Resume URL/File</div>
						  <button class="btn_close" aria-label="close" @click="cancelAddNewResume">
							 <span class="ic-close"></span>
						  </button>
						</div>

		    			<div class="row fld_row">
		                	<div class="col-1 fld_col_label">
		                  		<label>URL</label>
		                  	</div>
		                  	<div class="col-8 fld_col_input">
			                  	<input :disabled="isEditingResume" v-model="curriculumVitae.uri" placeholder="http://"></input>
		                  	</div>
		                </div>

		                <div class="row fld_row">
		                	<div class="col-1 fld_col_label">
		                  		<label for="newResumeFileName">File</label>
		                  	</div>
		                  	<div class="col-8 fld_col_input">
			                  	<input id="newResumeFileName" disabled v-model="curriculumVitae.fileName" placeholder="choose a file from your computer"></input>
		                  	</div>
		                  	<div class="col-3 fld_col_btn">
		                  		<b-btn :disabled="curriculumVitae.fileName && curriculumVitae.fileName.length && curriculumVitae.fileName.length > 0" @click.stop="chooseFile(false)">add file</b-btn>
		                  	</div>
		                </div>

		              <div slot="modal-footer">
		                <b-btn @click="addNewResume">save and next</b-btn>
		                <b-btn @click.stop="removeResumeClicked">clear</b-btn>
		              </div>
		            </b-modal>
		    	</div> <!-- section_content -->
		    </div> <!-- section_row -->


			<div class="row section_row">
		    	<div class="heading">
		    		<div class="ic"></div>
		    		<div class="hd_txt"><label for="personAddress">Address</label></div>
		    		<div class="btn_container"><b-btn @click="addAddressClicked">add</b-btn></div>
		    	</div> <!-- heading -->

		    	<div class="section_content">
		    		<template v-if="contactInfo && contactInfo.addresses && contactInfo.addresses.length">
		              	<div class="row">
							<div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 sec_col" id="personEmails" v-for="address in contactInfo.addresses">
								<div class="row">
				                	<div class="col-12 col_txt_row" v-if="address && address.type">
				                		<span class="title">{{address.type}}</span>
				                		<span class="icon-bin" @click="removeItemFromList(contactInfo.addresses, address)"></span>
				                	</div>

				                	<div class="col-12 col_txt_row" v-if="address && address.streetOne">Street One: {{address.streetOne}}</div>

				                	<div class="col-12 col_txt_row" v-if="address && address.streetTwo">Street Two: {{address.streetTwo}}</div>

				                	<div class="col-12 col_txt_row" v-if="address && address.city">City: {{address.city}}</div>

				                	<div class="col-12 col_txt_row" v-if="address && address.state">State: {{address.state}}</div>

				                	<div class="col-12 col_txt_row" v-if="address && address.country">Country: {{address.country}}</div>

				                	<div class="col-12 col_txt_row" v-if="address && address.zip">Zip: {{address.zip}}</div>
				              	</div>
			              	</div>
		              	</div>
		            </template>

		            <b-modal ref="modal" id="addNewAddress" v-model="showAddAddressModal" ok-disabled cancel-diasbled hide-header-close no-close-on-backdrop no-close-on-esc centered class="modal_popup">
					 <div slot="modal-header" class="popover-header">
						  <div class="popup-heading">Address</div>
						  <button class="btn_close" aria-label="close" @click="cancelAddNewAddress">
							 <span class="ic-close"></span>
						  </button>
						</div>
		                <div class="row fld_row">
		                	<div class="col-3 fld_col_label">
		                  		<label for="newGraduationYear">Address Type <span class="fld_req">*</span> </label>
		                  	</div>
		                  	<div class="col-8 fld_col_input">
			                  	<select id="newAddressType" v-model="newAddressType">
			                    	<option v-for="type in addressTypes" v-model="newAddressType">
			                      		{{ type }}
			                    	</option>
			                  	</select>
		                  	</div>
		                </div>

		                <div class="row fld_row">
		                	<div class="col-3 fld_col_label">
		                  		<label for="newAddressOne">Address 1 <span class="fld_req">*</span></label>
		                  	</div>
		                  	<div class="col-8 fld_col_input">
		                  		<input id="newAddressOne" v-model="newAddressOne" placeholder="type in address 1"></input>
		                  	</div>
		                </div>
		                <div class="row fld_row">
		                	<div class="col-3 fld_col_label">
		                  		<label for="newAddressTwo">Address 2</label>
							</div>
							<div class="col-8 fld_col_input">
		                  		<input id="newAddressTwo" v-model="newAddressTwo" placeholder="type in address 2"></input>
		                  	</div>
		                </div>
		                <div class="row fld_row">
		                	<div class="col-3 fld_col_label">
		                  		<label for="newCity">City <span class="fld_req">*</span></label>
		                  	</div>
		                  	<div class="col-8 fld_col_input">
		                  		<input id="newCity" v-model="newCity" placeholder="type city"></input>
		                  	</div>
		                </div>
		                <div class="row fld_row">
		                	<div class="col-3 fld_col_label">
		                  		<label for="newState">State <span class="fld_req">*</span></label>
		                  	</div>
		                  	<div class="col-8 fld_col_input">
		                  		<input id="newState" v-model="newState" placeholder="type in state"></input>
		                  	</div>
		                </div>
		                <div class="row fld_row">
		                	<div class="col-3 fld_col_label">
		                  		<label for="newCountry">Country <span class="fld_req">*</span></label>
		                  	</div>
		                  	<div class="col-8 fld_col_input">
		                  		<input id="newCountry" v-model="newCountry" placeholder="type in country"></input>
		                  	</div>
		                </div>
		                <div class="row fld_row">
		                	<div class="col-3 fld_col_label">
		                  		<label for="newZipCode">Zip Code</label>
		                  	</div>
		                  	<div class="col-8 fld_col_input">
		                  		<input id="newZipCode" v-model="newZipCode" placeholder="type in zip code"></input>
		                  	</div>
		                </div>

		              	<div slot="modal-footer">
		                	<b-button-group>
		                  		<span v-if="errors && errors.length > 0">{{errors}}</span>
		                  		<b-btn @click="cancelAddNewAddress">cancel</b-btn>
		                  		<b-btn @click="addNewAddress">save and next</b-btn>
		                  	</b-button-group>
		              	</div>

		            </b-modal>

		    	</div> <!-- section_content -->
		    </div> <!-- section_row -->


		</div> <!-- page-content -->
    <div class="loading-spinner">
        <b-modal style="padding: 0px;" ref="loadingModal" ok-disabled cancel-disabled hide-header hide-footer no-close-on-backdrop no-close-on-esc size="sm" centered>
            <div class="text-center" style="color: #FFF">
                <i class="fa fa-spinner fa-spin" style="font-size: 50px"></i>
            </div>
        </b-modal>
    </div>
	</div> <!-- module_person -->
</template>

<script>
  /* global AWS:true */
  import { mapState, mapActions } from 'vuex'
  import _ from 'lodash'
  import Editor from '@tinymce/tinymce-vue'
  import AddTagPopup from '../../tagging/components/AddTagPopup'
  import { AwsObject } from '../aws'

  var getFileName = function (fileName) {
    if (!fileName && fileName !== null) {
      return null
    }
    return fileName.replace(/\.\w+$/g, '')
  }

  var getUpdatedFileName = function (title, fileName) {
    var ext = fileName.substr((~-fileName.lastIndexOf('.') >>> 0) + 2)
    if (ext !== '' || ext !== null) {
      return (title + '.' + ext)
    } else {
      return fileName
    }
  }

  var FileObject = function (title, file, size, timestamp, type) {
    console.log('creating file: ', file)
    this.title = getFileName(title)
    this.file = file
    this.fileName = getUpdatedFileName(this.title, title)
    this.size = size
    this.contentFileType = type
    this.timestamp = timestamp
    this.id = timestamp
    // added
    // this.uri = file.uri
  }

  var clone = function (obj) {
    if (obj === null || typeof obj !== 'object') return obj
    var copy = obj.constructor()
    for (var attr in obj) {
      if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr]
    }
    return copy
  }

  export default {
    name: 'edit-person',
    props: ['uuid', 'loadDataFromServer'],
    components: {
      Editor,
      AddTagPopup
    },
    data: () => {
      return {
        userId: {},
        selectedRow: undefined,
        selectedCourse: {},
        showResume: false,
        monthMap: {
          0: 'January',
          1: 'February',
          2: 'March',
          3: 'April',
          4: 'May',
          5: 'June',
          6: 'July',
          7: 'August',
          8: 'September',
          9: 'October',
          10: 'November',
          11: 'December'
        },
        personPrefixTypes: ['Mr.', 'Ms.', 'Mrs.', 'Dr.', 'Prof.'],
        emailTypes: ['work', 'personal'],
        addressTypes: ['work', 'personal'],
        phoneTypes: ['work', 'personal', 'mobile'],
        socialTypes: ['facebook', 'linkedin', 'twitter'],
        years: ['1970', '1971', '1972', '1973', '1974', '1975', '1976', '1977', '1978', '1979', '1980', '1981', '1982', '1983', '1984', '1985', '1986', '1987', '1988', '1989', '1990', '1991', '1992', '1993', '1994', '1995', '1996', '1997', '1998', '1999', '2000', '2001', '2002', '2003', '2004', '2005', '2006', '2007', '2008', '2009', '2010', '2011', '2012', '2013', '2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022', '2023', '2024', '2025'],
        months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        personTypes: ['Faculty', 'Mentor', 'Alumni', 'Staff', 'Guest', 'Advisor', 'Student'],
        personType: '',
        firstName: '',
        middleName: '',
        lastName: '',
        biography: '',
        areaOfInterestTerms: [],
        experienceInfoList: [],
        educationInfoList: [],
        curriculumVitae: {},
        contactInfo: {
          'addresses': [],
          'eMailList': [],
          'phoneList': [],
          'socialList': [],
          'websiteList': [],
          'contactsList': []
        },
        eMailList: [],
        addresses: [],
        phoneList: [],
        socialList: [],
        websiteList: [],
        thumbnailURI: '',
        thumbnail: '',
        thumbnailURICopy: '',
        thumbnailCopy: '',
        showAddInterestModal: false,
        showAddExperienceModal: false,
        showAddEducationModal: false,
        showAddResumeModal: false,
        showAddEmailModal: false,
        showAddAddressModal: false,
        showAddPhoneModal: false,
        showAddSocialModal: false,
        showAddWebsiteModal: false,
        showAddThumbnailModal: false,
        namePrefix: '',
        nameSuffix: '',
        newInterest: '',
        newExperience: '',
        newEducation: '',
        resumeUrl: '',
        newResumeFile: '',
        newEmailType: '',
        newEmailAddress: '',
        newAddress: {},
        newPhone: {},
        newSocial: {},
        newWebsite: '',
        newJobTitle: '', // fields for adding new Experience
        newJobDescription: '',
        newEmployer: '',
        newIndustry: '',
        newExperienceLocation: '',
        newExperienceStartMonth: '',
        newExperienceStartYear: '',
        newExperienceEndMonth: '',
        newExperienceEndYear: '',
        newInstitutionName: '', // fields for adding new Education
        newDegree: '',
        newGraduationYear: '',
        newMajorOne: '',
        newMajorTwo: '',
        newMinor: '',
        newConcentration: '',
        newEducationStartMonth: '',
        newEducationStartYear: '',
        newEducationEndMonth: '',
        newEducationEndYear: '',
        newAddressType: '',
        newAddressOne: '',
        newAddressTwo: '',
        newCity: '',
        newState: '',
        newCountry: '',
        newZipCode: '',
        newPhoneType: '',
        newPhoneNumber: '',
        newSocialType: '',
        newSocialUrl: '',
        newWebsiteUrl: '',
        isEditing: false,
        isPursuingExperience: false,
        isPursuingEducation: false,
        isBulkUpload: false,
        plugins: 'charmap code hr link searchreplace textcolor autoresize media image imagetools',
        toolbar: 'bold italic underline styleselect bullist numlist outdent indent forecolor backcolor removeformat link unlink searchreplace undo redo alignleft aligncenter alignright alignjustify media insertfile image',
        fileUploadArray: [],
        errors: [],
        owningLibrary: {},
        isEditingResume: false,
        isUploadingThumbnail: false,
        createUser: false,
        shouldShowLoader: true,
        showPreview: true,
        appliedTagMap: {},
        taggingEntityData: {},
        isShowTagPopup: false
      }
    },
    created () {
      window.addEventListener('unload', this.goToDetail)
    },
    mounted () {
      // TODO detect page refresh and route back to detail
      const userId = localStorage.getItem('userid')
      this.loadLibrariesForUser(userId).then(learningSpaces => {
        this.folders = []
        for (var i = 0; i < learningSpaces.length; i++) {
          const learningSpace = learningSpaces[i]
          const permission = learningSpace.acelist[0].permission
          if (permission && permission.folderPermission && permission.folderPermission.allowedAsDestinationFolder) {
            this.folders.push(learningSpace)
            if (learningSpace.category === 'Institute_Public') {
              this.owningLibrary = {uuid: learningSpace.uuid, displayName: learningSpace.displayName}
            }
          }
        }
        if (this.folders.length > 0 && _.isEmpty(this.owningLibrary)) {
          this.owningLibrary = {uuid: this.folders[0].uuid, displayName: this.folders[0].displayName}
        }
      })
      this.loadCurrentEnvironment().then(res => {
        AwsObject(res)
      })
      this.loadDataForPersonDetail()
    },

    methods: {
      ...mapActions([
        'loadPerson',
        'storePerson',
        'loadLibrariesForUser',
        'uploadContentAndGetUri',
        'updateFileUriAndVersionIdAfterS3Upload',
        'loadCurrentEnvironment'
      ]),
      showAll () {
        this.$root.$emit('bv::show::modal', 'personDesc')
      },
      closeshowAll () {
        this.$root.$emit('bv::hide::modal', 'personDesc')
      },
      goToDetail () {
        this.$router.push({ name: 'personDetail', params: { uuid: this.uuid } })
      },
      loadDataForPersonDetail () {
        this.loadPerson({ uuid: this.uuid, loadDataFromServer: this.loadDataFromServer }).then(response => {
          this.uuid = response.uuid.slice(0)
          this.createUser = (response.createUser) ? (response.createUser) : false
          this.personType = response.personType.slice(0)
          this.firstName = response.firstName.slice(0)
          this.lastName = response.lastName.slice(0)
          this.biography = (response.biography) ? response.biography.slice(0) : ''
          this.middleName = (response.middleName) ? response.middleName.slice(0) : ''
          this.namePrefix = (response.prefix) ? response.prefix.slice(0) : ''
          this.nameSuffix = (response.suffix) ? response.suffix.slice(0) : ''
          this.thumbnailURI = (response.thumbnailURI) ? response.thumbnailURI.slice(0) : ''
          this.thumbnail = (response.thumbnail) ? response.thumbnail.slice(0) : ''
          this.areaOfInterestTerms = (response.areaOfInterestTerms) ? response.areaOfInterestTerms.slice(0) : []
          this.experienceInfoList = (response.experienceInfoList) ? response.experienceInfoList.slice(0) : []
          this.educationInfoList = (response.educationInfoList) ? response.educationInfoList.slice(0) : []
          this.contactInfo = (response.contactInfo) ? _.cloneDeep(response.contactInfo) : this.contactInfo
          this.curriculumVitae = (response.curriculumVitae) ? _.cloneDeep(response.curriculumVitae) : this.curriculumVitae
          if (response.appliedTagMap) {
            this.appliedTagMap = response.appliedTagMap
          }
        })
      },
      buildTimeRangeLabel (from, to) {
        let monthMap = this.monthMap // maps 0 -> Jan, 1 -> Feb, ....
        // string 'from' is guaranteed to be set from the backend, checking in case
        if (!from) {
          return ''
        }

        // create label prefix in human readable date format instead of UTC
        let dateTime = new Date(from)
        let label = monthMap[dateTime.getMonth()] + ', ' + dateTime.getFullYear() + ' - '

        if (to && !(to instanceof Date)) {
          dateTime = new Date(to)
          label += monthMap[dateTime.getMonth()] + ', ' + dateTime.getFullYear()
        } else if (to && to instanceof Date && !isNaN(to.getMonth())) { // date is valid
          dateTime = to
          label += monthMap[dateTime.getMonth()] + ', ' + dateTime.getFullYear()
        } else {
          label += 'Present'
        }
        return label
      },
      personDataIsValid () {
        if (this.personType && this.uuid && this.firstName && this.lastName) {
          return true
        }
        if (!this.firstName && !this.lastName) {
          this.errors.push('First name and Last name cannot be blank. Please provide person\'s first name and last name.')
          return false
        }
        if (!this.firstName) {
          this.errors.push('First Name cannot be blank. Please provide person\'s first name.')
        }
        if (!this.lastName) {
          this.errors.push('Last Name cannot be blank. Please provide person\'s last name.')
        }
        if (!this.personType) {
          this.errors.push('A person must have a person type associated with it (i.e. \'Faculty\', \'Guest\', \'Student\', etc.).')
        }
        return false
      },
      onSubmit (isDone) {
        if (!this.personDataIsValid()) {
          this.$notify({
            group: 'notify',
            type: 'error',
            title: '',
            text: this.errors.join('\n')
          })
          this.errors = []
          return
        }
        this.submitted = true

        const personData = {
          uuid: this.uuid,
          firstName: this.firstName,
          middleName: this.middleName,
          lastName: this.lastName,
          suffix: this.nameSuffix,
          prefix: this.namePrefix,
          biography: this.biography,
          experienceInfoList: this.experienceInfoList,
          educationInfoList: this.educationInfoList,
          thumbnailURI: this.thumbnailURI,
          thumbnail: this.thumbnail,
          contactInfo: this.contactInfo,
          createUser: this.createUser,
          appliedTagMap: this.appliedTagMap,
          areaOfInterestTerms: this.areaOfInterestTerms,
          curriculumVitae: this.curriculumVitae,
          personType: this.personType
        }
        this.storePerson(personData).then(response => {
          if (isDone) {
            return this.$router.push({ name: 'personDetail', params: { uuid: this.uuid } })
          } else {
            this.$notify({
              group: 'notify',
              type: 'success',
              title: '',
              text: 'Person "' + this.firstName + ' ' + this.lastName + '" updated successfully.'
            })
            this.submitted = false
          }
        })
      },
      addInterestClicked () {
        this.showAddInterestModal = true
      },
      addExperienceClicked () {
        this.showAddExperienceModal = true
      },
      addEducationClicked () {
        this.showAddEducationModal = true
      },
      addResumeClicked () {
        this.showAddResumeModal = true
      },
      addEmailClicked () {
        this.showAddEmailModal = true
      },
      addAddressClicked () {
        this.showAddAddressModal = true
      },
      addPhoneClicked () {
        this.showAddPhoneModal = true
      },
      addSocialClicked () {
        this.showAddSocialModal = true
      },
      addWebsiteClicked () {
        this.showAddWebsiteModal = true
      },
      addThumbnailClicked () {
        this.showAddThumbnailModal = true
        this.thumbnailURICopy = this.thumbnailURI.slice(0)
        this.thumbnailCopy = this.thumbnail.slice(0)
      },
      removeResumeClicked () {
        this.isEditingResume = true
        this.curriculumVitae = {}
      },
      removeThumbnailClicked () {
        this.thumbnailURI = ''
        this.thumbnail = ''
        this.isUploadingThumbnail = false
        this.showPreview = true
      },
      removeItemFromList (list, item) {
        list.splice(list.indexOf(item), 1)
      },
      updateItemInList (list, item) {
        list.splice(list.indexOf(item), 1)
      },
      addNewInterest () {
        if (!this.newInterest) {
          return
        }
        this.areaOfInterestTerms.push(this.newInterest)
        this.newInterest = ''
      },
      isValidYearFormat (yearString) {
        // TODO
        return true
      },
      datesRangeIsValid (startMonth, startYear, endMonth, endYear) {
        if (startMonth && startYear && !endMonth && !endYear) {
          return true
        }
        // TODO enforce that startYear and endYear are numeric and in 'YYYY' format
        if (!this.isValidYearFormat(startYear) || !this.isValidYearFormat(endYear)) {
          this.errors = 'Years must not be before 1970 and must be in YYYY format.'
        }
        return new Date(startMonth + ' ' + startYear) < new Date(endMonth + ' ' + endYear)
      },
      editExperience (experience) {
        let from
        let to
        if (experience.from) {
          from = new Date(experience.from)
        }
        if (experience.to) {
          to = new Date(experience.to)
        }
        this.newJobTitle = experience.title
        this.newEmployer = experience.employer
        this.newIndustry = experience.industry
        this.newExperienceLocation = experience.location
        this.newJobDescription = experience.description
        this.newExperienceStartMonth = (from) ? this.monthMap[from.getMonth()] : ''
        this.newExperienceStartYear = (from) ? from.getFullYear() : ''
        this.newExperienceEndMonth = (to) ? this.monthMap[to.getMonth()] : ''
        this.newExperienceEndYear = (to) ? to.getFullYear() : ''
        this.showAddExperienceModal = true
        this.isEditing = true
        this.errors = []
      },
      editEducation (education) {
        let from
        let to
        if (education.startYear) {
          from = new Date(education.startYear)
        }
        if (education.finishYear) {
          to = new Date(education.finishYear)
        }

        this.newInstitutionName = education.institution
        this.newDegree = education.degree
        this.newGraduationYear = education.classOf
        this.newMajorOne = education.majorOne
        this.newMajorTwo = education.majorTwo
        this.newMinor = education.minor
        this.newConcentration = education.concentration
        this.newEducationStartMonth = (from) ? this.monthMap[from.getMonth()] : ''
        this.newEducationStartYear = (from) ? from.getFullYear() : ''
        this.newEducationEndMonth = (to) ? this.monthMap[to.getMonth()] : ''
        this.newEducationEndYear = (to) ? to.getFullYear() : ''
        this.showAddEducationModal = true
        this.isEditing = true
        this.errors = []
      },
      cancelAddNewExperience () {
        this.newJobTitle = ''
        this.newEmployer = ''
        this.newIndustry = ''
        this.newExperienceLocation = ''
        this.newJobDescription = ''
        this.newExperienceStartMonth = ''
        this.newExperienceStartYear = ''
        this.newExperienceEndMonth = ''
        this.newExperienceEndYear = ''
        this.showAddExperienceModal = false
        this.errors = []
      },
      cancelAddNewEducation () {
        this.newDegree = ''
        this.newGraduationYear = ''
        this.newMajorOne = ''
        this.newMajorTwo = ''
        this.newMinor = ''
        this.newInstitutionName = ''
        this.newConcentration = ''
        this.newEducationStartMonth = ''
        this.newEducationStartYear = ''
        this.newEducationEndMonth = ''
        this.newEducationEndYear = ''
        this.showAddEducationModal = false
        this.errors = []
      },
      cancelAddNewEmail () {
        this.newEmailType = ''
        this.newEmailAddress = ''
        this.showAddEmailModal = false
        this.errors = []
      },
      cancelAddNewAddress () {
        this.newAddressType = ''
        this.newAddressOne = ''
        this.newAddressTwo = ''
        this.newCity = ''
        this.newState = ''
        this.newCountry = ''
        this.newZipCode = ''
        this.showAddAddressModal = false
        this.errors = []
      },

      cancelAddNewResume () {
        this.curriculumVitae.uri = ''
        this.curriculumVitae.fileName = ''
        this.showAddResumeModal = false
        this.errors = []
      },

      cancelAddPhone () {
        this.newPhoneType = ''
        this.newPhoneNumber = ''
        this.showAddPhoneModal = false
        this.errors = []
      },
      cancelAddSocial () {
        this.newSocialType = ''
        this.newSocialUrl = ''
        this.showAddSocialModal = false
        this.errors = []
      },
      cancelAddWebsite () {
        this.newWebsiteUrl = ''
        this.showAddWebsiteModal = false
        this.errors = []
      },
      cancelAddEmail () {
        this.newEmailType = ''
        this.newEmailAddress = ''
        this.showAddEmailModal = false
        this.errors = []
      },
      cancelAddThumbnail () {
        this.thumbnailURI = this.thumbnailURICopy
        this.thumbnail = this.thumbnailCopy
        this.isUploadingThumbnail = false
        this.showAddThumbnailModal = false
        this.errors = []
      },
      addNewExperience () {
        if (!this.newJobTitle || !this.newEmployer || !this.newIndustry || !this.newExperienceLocation) {
          this.errors = 'Fields marked with * are required'
          return
        }
        if (!this.datesRangeIsValid(this.newExperienceStartMonth, this.newExperienceStartYear, this.newExperienceEndMonth, this.newExperienceEndYear)) {
          this.errors = 'End Date cannot be before Start Date'
          return
        }
        this.errors = []
        this.newExperience = {
          title: this.newJobTitle,
          pragyaTitle: null,
          description: this.newJobDescription,
          employer: this.newEmployer,
          location: this.newExperienceLocation,
          locationCountry: null,
          industry: this.newIndustry,
          pragyaIndustry: null,
          career: null,
          from: new Date(this.newExperienceStartMonth + ' ' + this.newExperienceStartYear),
          to: (this.newExperienceEndMonth) ? new Date(this.newExperienceEndMonth + ' ' + this.newExperienceEndYear) : ''
        }

        // build human readable time string based on dates entered
        let from = this.newExperience.from
        let to = this.newExperience.to
        this.newExperience.experienceTimeLabel = this.buildTimeRangeLabel(from, to)

        if (this.isEditing) {
          // Vue 2.0 requires us to replace the entire array instead of a single entry
          let newExperienceInfoList = []
          this.experienceInfoList.forEach(item => {
            if (item.title === this.newExperience.title) {
              newExperienceInfoList.push(this.newExperience)
            } else {
              newExperienceInfoList.push(item)
            }
          })
          this.experienceInfoList = newExperienceInfoList
          this.isEditing = false
        } else {
          this.experienceInfoList.push(this.newExperience)
          this.newExperience = {}
        }

        // clear the fields and close the modal
        this.cancelAddNewExperience()
      },
      addNewEducation () {
        if (!this.newInstitutionName || !this.newDegree || !this.newGraduationYear || !this.newMajorOne) {
          this.errors = 'Fields marked with * are required'
          return
        }
        if (!this.datesRangeIsValid(this.newEducationStartMonth, this.newEducationStartYear, this.newEducationEndMonth, this.newEducationEndYear)) {
          this.errors = 'End Date cannot be before Start Date'
          return
        }
        this.errors = []

        this.newEducation = {
          degree: this.newDegree,
          classOf: this.newGraduationYear,
          majorOne: this.newMajorOne,
          majorTwo: this.newMajorTwo,
          minor: this.newMinor,
          institution: this.newInstitutionName,
          concentration: this.newConcentration,
          startYear: new Date(this.newEducationStartMonth + ' ' + this.newEducationStartYear),
          finishYear: (this.newEducationEndMonth) ? new Date(this.newEducationEndMonth + ' ' + this.newEducationEndYear) : ''
        }

        // build human readable time string based on dates entered
        let from = this.newEducation.startYear
        let to = this.newEducation.finishYear
        this.newEducation.educationTimeLabel = this.buildTimeRangeLabel(from, to)

        // TODO
        if (this.isEditing) {
          // Vue 2.0 requires us to replace the entire array instead of a single entry
          let newEducationInfoList = []
          this.educationInfoList.forEach(item => {
            if (item.institution === this.newEducation.institution) {
              newEducationInfoList.push(this.newEducation)
            } else {
              newEducationInfoList.push(item)
            }
          })
          this.educationInfoList = newEducationInfoList
          this.isEditing = false
        } else {
          this.educationInfoList.push(this.newEducation)
          this.newEducation = {}
        }

        // clear the fields and close the modal
        this.cancelAddNewEducation()
      },
      addNewAddress () {
        if (!this.newAddressType || !this.newAddressOne || !this.newCity || !this.newState || !this.newCountry) {
          this.errors = 'Fields marked with * are required'
          return
        }
        this.errors = []

        this.newAddress = {
          type: this.newAddressType,
          streetOne: this.newAddressOne,
          streetTwo: this.newAddressTwo,
          city: this.newCity,
          zip: this.newZipCode,
          country: this.newCountry
        }

        this.contactInfo.addresses.push(this.newAddress)
        this.newAddress = {}

        // clear the fields and close the modal
        this.cancelAddNewAddress()
      },
      addNewPhone () {
        if (!this.newPhoneType || !this.newPhoneNumber) {
          this.errors = 'Fields marked with * are required'
          return
        }
        this.errors = []

        this.newPhone = {
          type: this.newPhoneType,
          value: this.newPhoneNumber
        }

        this.contactInfo.phoneList.push(this.newPhone)
        this.newPhone = {}

        // clear the fields and close the modal
        this.cancelAddPhone()
      },
      addNewSocial () {
        if (!this.newSocialType || !this.newSocialUrl) {
          this.errors = 'Fields marked with * are required'
          return
        }
        this.errors = []

        this.newSocial = {
          type: this.newSocialType,
          value: this.newSocialUrl
        }

        this.contactInfo.socialList.push(this.newSocial)
        this.newSocial = {}

        // clear the fields and close the modal
        this.cancelAddSocial()
      },
      addNewWebsite () {
        if (!this.newWebsiteUrl) {
          this.errors = 'This field is required'
          return
        }
        this.errors = []

        this.newWebsite = {
          value: this.newWebsiteUrl
        }

        this.contactInfo.websiteList.push(this.newWebsite)
        this.newWebsite = {}

        // clear the fields and close the modal
        this.cancelAddWebsite()
      },
      addNewEmail () {
        if (!this.newEmailAddress) {
          this.errors = 'Fields marked with * are required'
          return
        }
        this.errors = []

        this.newEmail = {
          type: this.newEmailType,
          value: this.newEmailAddress
        }

        this.contactInfo.eMailList.push(this.newEmail)

        // clear the fields and close the modal
        this.cancelAddNewEmail()
      },
      showAddTagPopup (event) {
        this.isShowTagPopup = true
        let title = (this.person.prefix || '') + ' ' + (this.person.firstName || '') + ' ' + (this.person.middleName || '') + ' ' + (this.person.lastName || '') + ' ' + (this.person.suffix || '')
        this.taggingEntityData = {title: title, type: 'person', appliedTagMap: this.appliedTagMap}
        setTimeout(() => {
          this.$root.$emit('bv::show::modal', 'addTagPopup', event.target)
        }, 500)
      },
      addNewResume () {
        this.uploadFiles('curriculumVitae')
        this.showAddResumeModal = false
        this.isEditingResume = false
      },
      addNewThumbnail () {
        this.uploadFiles('thumbnail')
        this.showAddThumbnailModal = false
        this.isUploadingThumbnail = false
        // last edit was made through URI input because 'add file' sets these equal
        if (this.thumbnailURI !== this.thumbnail) {
          this.thumbnail = this.thumbnailURI
        }
      },
      chooseFile (isThumbnailUpload) {
        let el = (isThumbnailUpload) ? 'thumbnailFileList' : 'fileListId'
        let sel = 'id=' + el
        if (el === 'fileListId') {
          sel = 'rel=multipleFile'
        }
        $('input[type=file][' + sel + ']').click()
      },
      fileToBeUploaded (ev) {
        var files = ev.target.files || ev.dataTransfer.files
        if (!files.length) {
          return
        }
        this.curriculumVitae = files[0]
        this.curriculumVitae.fileName = files[0].name
        this.prepareFileUploadArray(files)
      },
      thumbnailToBeUploaded (ev) {
        var files = ev.target.files || ev.dataTransfer.files
        if (!files.length) {
          return
        }
        this.isUploadingThumbnail = true
        this.thumbnailURI = files[0].name
        this.thumbnail = files[0].name
        this.prepareFileUploadArray(files)
        this.showPreview = false
      },
      prepareFileUploadArray (files) {
        if (files) {
          let timestamp = new Date().getTime()
          for (var i = 0; i < files.length; i++) {
            timestamp = timestamp + i
            this.addFileToUploadArray(files[i], timestamp)
          }
        }
      },
      addFileToUploadArray (newFile, timestamp) {
        let isFound = _.find(this.fileUploadArray, function (file) {
          return ((newFile.name === file.title) && (newFile.size === file.size))
        })

        if (!isFound) {
          this.fileUploadArray.push(new FileObject(newFile.name, newFile, newFile.size, timestamp, newFile.type))
        }
      },
      uploadFiles (contentType) {
        let fileUploadArrayClone = clone(this.fileUploadArray)
        let contentListToCreate = []
        for (var i = 0; i < fileUploadArrayClone.length; i++) {
          let content = fileUploadArrayClone[i]
          console.log('creating content item: ', content)
          let item = {
            'title': content.title,
            'lastModifiedDate': content.contentFileType.timestamp,
            'contentFileType': content.contentFileType,
            'fileName': content.fileName,
            'timestamp': content.timestamp,
            'thumbnail': content.thumbnail
          }
          contentListToCreate.push(item)
        }
        if (contentListToCreate.length <= 0) {
          return
        }
        let successCallBack = contentType === 'thumbnail' ? this.handleThumbnailUploadSuccess : this.handleCurriculumVitaeUpload
        this.showLoader()
        this.uploadContentAndGetUri({learningSpaceId: this.owningLibrary.uuid, contents: contentListToCreate, success: successCallBack, failure: this.uploadFileAfterCreateContentErrorCallback})
      },
      cancelClicked () {
        return this.$router.push({ name: 'personDetail', params: { uuid: this.uuid } })
      },
      uploadFileAfterCreateContentSuccessCallback (response, isThumbnailResponse) {
        var createdContents = response.createdContents
        var skippedContents = response.skippedContents
        if (createdContents.length > 0) {
          // uploading files on S3 for created contents
          var fileUploadArrayClone = clone(this.fileUploadArray)
          this.uploadLearningContentFilesOnS3(createdContents, fileUploadArrayClone, isThumbnailResponse)
        }
        this.removeProcessedContents(createdContents, skippedContents)
        this.fileUploadArray = []
      },
      handleThumbnailUploadSuccess (response) {
        this.uploadFileAfterCreateContentSuccessCallback(response, true)
        this.showPreview = true
      },
      handleCurriculumVitaeUpload (response) {
        this.uploadFileAfterCreateContentSuccessCallback(response, false)
      },
      uploadFileAfterCreateContentErrorCallback (response) {
        console.log('Error occured while creating content(s) ', response)
        this.hideLoader()
      },
      uploadLearningContentFilesOnS3 (createdContents, fileUploadArrayClone, isThumbnailResponse) {
        var filesToBeUploaded = []
        $.each(createdContents, (index, content) => {
          for (var i = 0; i < fileUploadArrayClone.length; i++) {
            var fileData = fileUploadArrayClone[i]
            if (content.fileName === fileData.fileName) {
              var key = content.uuid + '-' + content.fileName
              filesToBeUploaded.push({'uuid': content.uuid, 'key': key, 'uri': content.uri, 'fileData': fileData})
              break
            }
          }
        })
        if (filesToBeUploaded.length > 0) {
          this.storeFilesToS3(filesToBeUploaded, isThumbnailResponse)
        }
      },
      storeFilesToS3 (filesToBeUploaded, isThumbnailResponse) {
        var awsRef = new AWS.S3()
        var s3Bucket = this.currentEnvironment.s3Bucket
        $.each(filesToBeUploaded, (i, item) => {
          var params = {
            Key: item.key,
            Bucket: s3Bucket,
            ContentType: item.fileData.contentFileType,
            ACL: 'public-read',
            Body: item.fileData.file
          }
          awsRef.putObject(params, (err, data) => {
            if (err) {
              console.log('Uploading Learning Content File Failed On S3: ' + err.stack)
            } else {
              let uri = item.uri
              if (uri.indexOf('?versionId=') === -1) {
                uri = uri.concat('?versionId=' + data.VersionId)
                this.updateFileUriAndVersionIdAfterS3Upload({uuid: item.uuid, uri: uri})
              }
            }
            let uploadedFile = filesToBeUploaded[0]
            if (isThumbnailResponse) {
              this.thumbnailURI = uploadedFile.uri
              this.thumbnail = uploadedFile.uri
            } else {
              this.curriculumVitae.uuid = uploadedFile.uuid
              this.curriculumVitae.uri = uploadedFile.uri
              this.curriculumVitae.title = uploadedFile.fileData.title
              this.curriculumVitae.fileName = uploadedFile.fileData.fileName
              this.curriculumVitae.contentFileType = uploadedFile.fileData.contentFileType
            }
            this.hideLoader()
          })
        })
      },
      removeProcessedContents (createdContents, skippedContents) {
        var allContents = []
        if (createdContents.length > 0) {
          $.each(createdContents, (i, created) => {
            allContents.push(created)
          })
        }
        if (skippedContents.length > 0) {
          $.each(createdContents, (i, skipped) => {
            allContents.push(skipped)
          })
        }
        if (allContents.length > 0) {
          $.each(allContents, (i, content) => {
            $.each(this.fileUploadArray, (j, item) => {
              if (content.timestamp.toString() === item.timestamp.toString()) {
                this.fileUploadArray.splice(j, 1)
                return false
              }
            })
          })
        }
      },
      filePickerCallback (callback, value, meta) {
        if (meta.filetype === 'image') {
          $('#upload').trigger('click')
          $('#upload').on('change', function () {
            var file = this.files[0]
            var reader = new FileReader()
            reader.onload = function (e) {
              callback(e.target.result, {
                alt: ''
              })
            }
            reader.readAsDataURL(file)
          })
        }
      },
      showLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.show()
        }
      },
      hideLoader () {
        if (this.$refs.loadingModal) {
          this.$refs.loadingModal.hide()
        }
      }
    },
    computed: {
      ...mapState({
        'person': state => state.person.personObject,
        'learningSpaces': state => state.assessment.learningSpaces,
        'ownerId': state => state.person.personObject.ownerId,
        'owningLibraryId': state => state.person.personObject.owningLibraryId,
        'currentEnvironment': state => state.learningContent.currentEnvironment
      }),
      formattedPerson () {
        let formattedPerson = this.person
        if (!formattedPerson) {
          return {}
        }
        let buildTimeRangeLabel = this.buildTimeRangeLabel
        if (formattedPerson.experienceInfoList) {
          let experienceInfoList = this.experienceInfoList
          experienceInfoList = []
          formattedPerson.experienceInfoList.forEach(experience => {
            experience.experienceTimeLabel = buildTimeRangeLabel(experience.from, experience.to)
            experienceInfoList.push(_.cloneDeep(experience))
          })
        }
        if (formattedPerson.educationInfoList) {
          let educationInfoList = this.educationInfoList
          educationInfoList = []
          formattedPerson.educationInfoList.forEach(education => {
            education.educationTimeLabel = buildTimeRangeLabel(education.from, education.to)
            educationInfoList.push(_.cloneDeep(education))
          })
        }
        return formattedPerson
      }
    },
    watch: {
      isPursuingExperience (newFlag) {
        this.newExperienceEndMonth = ''
        this.newExperienceEndYear = ''
      },
      isPursuingEducation (newFlag) {
        this.newEducationEndMonth = ''
        this.newEducationEndYear = ''
      }
    }
  }
</script>

<style scoped>
.input-group {
  z-index: 2;
}

.hidden-container {
  visibility: hidden;
  height: 1px;
}

.heading {
  font-size: 20px;
}

.tag-container {
	max-height: fit-content !important;
}

.label {
  font-size: 20px;
  font-weight: bold;
}

.lnk_txt {
    margin-left: 42px;
    width: 75%;
    display: inline-block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/app/person/components/EditPerson.vue